//Set loader image


var loaderImage = "https://loading.io/spinners/dual-ring/lg.dual-ring-loader.gif";


// Set unique values for the array "ar"
function uniqueArray(ar) {
    var j = {};

    ar.forEach(function (v) {
        j[v + '::' + typeof v] = v;
    });

    return Object.keys(j).map(function (v) {
        return j[v];
    });
}



// Equalize blocks height by setting the same min-height value
function equalizeBlocks() {
    var blockArray = $('[data-eq]').map(function () {
        return $(this).data('eq');
    }).get();
    var blocks = uniqueArray(blockArray);

    blocks.forEach(function (elem) {
        var prev = 0;
        $('[data-eq="' + elem + '"]')
            .css('min-height', '')
            .each(function () {
                if ($(this).outerHeight() > prev) {
                    prev = $(this).outerHeight();
                }
            })
            .css('min-height', prev + 'px');
    });
}

// Square blocks height
function squareBlocks() {
    $('[data-square]').css('min-height', '');
    $('[data-square]').each(function(ev){
        $(this).css('min-height', $(this).outerWidth());
    });
}

$(function() {
    if (!$.fn.bootstrapDP && $.fn.datepicker && $.fn.datepicker.noConflict) {
        var datepicker = $.fn.datepicker.noConflict();
        $.fn.bootstrapDP = datepicker;
    }
});




// ----------------------------------------- //
// DOM READY
$(document).ready(function ($) {
    "use strict";

    $('.select2-init').select2();

    $('body').on('focus', '.input-datepicker', function() {
        $(this).bootstrapDP({
            language: "fr"
        });

        // General


        /*setTimeout(function() {
            $(".ui-datepicker-month, .ui-datepicker-year").selectmenu();
        }, 10);
*/

        //var md = new MobileDetect(window.navigator.userAgent);
        //if (md.mobile()) {
        //    $(this).prop('type', 'date');
        //    $(this).datepicker('destroy');
        //}
        //else {
        //    $(this).prop('type', 'text');
        //
        //    $(this).datepicker({
        //        changeMonth: true,
        //        changeYear: true
        //    });
        //}
    });

    $("#event_begin").bootstrapDP({
        language: "fr",
        autoclose: true,
    }).on('changeDate', function (selected) {
        var minDate = new Date(selected.date.valueOf());
        $('#event_end').bootstrapDP('setStartDate', minDate);
    });

    $("#event_end").bootstrapDP({
        language: "fr"
    }).on('changeDate', function (selected) {
        var maxDate = new Date(selected.date.valueOf());
        $('#event_begin').bootstrapDP('setEndDate', maxDate);
    });


    $.datepicker.setDefaults( $.datepicker.regional[ localeDatePicker ] );

    // Trigger tooltips
    $('[data-toggle="tooltip"]').tooltip();

    // Toggle form in-box (posts)
    $(document).on('click','.toggle-post-box-form',function() {
        var $this = $(this);
        $this.parents('.box__frame').find('.box__content-wrapper').toggle();
        $this.parents('.box__frame').find('.box__form-wrapper').toggle();
        $('.fa', this).toggle();
    });

    // Toggle form in-box (profile, projects...)
    $(document).on('click','.toggle-box-form',function() {
        var $this = $(this);
        $this.prev('.box__content-wrapper').toggle();
        $this.next('.box__form-wrapper').toggle();
        $('.fa', this).toggle();
    });

    $(document).on('click','.toggle-add-form',function() {
        $(this).parent('.box__actions').next('.box__form-wrapper').toggle();
        $(this).hide();
    });

    // Disable input copy/paste
    $('.no-paste').bind('copy paste', function (e) {
        e.preventDefault();
    });

    // Block Ref - Slider
    var $slider = $('.slider-ref');
    var $progressBar = $('.progress__item');
    var $progressItem = $('.progress__item');

    $slider.on('init', function(event, slick) {
        var calc = ( 1 / (slick.slideCount) ) * 100;
        $progressItem.css('width', calc + '%');
    });

    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        //var calc = ( (nextSlide) / (slick.slideCount - 1) ) * 100;
        var calc = nextSlide * (1 / (slick.slideCount)) * 100;
        $progressBar.css('left', calc + '%');
    });

    // Registration : Accompanist form -> Support structure creation invitation mail ajax
    $("#supportStructureInviteForm").on("submit", function(e) {

        $('body').addClass('is-loading');
        var data = $("#supportStructureInviteForm").serialize();
        $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'async': false,
            'data': data + '&action=supportStructureInviteAction',
            success: function (response) {
                var res = JSON.parse(response);
                $(".accompanist-form__supportStructureInviteForm").append(res);
            }
        }).always(function () {
            $('body').removeClass('is-loading');
        });

        e.preventDefault();
    });

    // Repeat project example fields in support structure form
    $('#supportStructureProjectExampleForm').repeater({
        repeaters: [{
            selector: '.project_images'
        }]
    });

    // Resize block figures grid on synthesis
    function resizeFigureGrid() {
        $(".synthesis-modal").on('shown.bs.modal', function(e) {
            $('.figures-grid-cell').each(function () {
                $(this).css('min-height', ($(this).width() + 40)); // 40 is padding
            });
            equalizeBlocks();
        });
    }
    resizeFigureGrid();

    $(window).on('resize', function() {
        resizeFigureGrid();
    });

    // Add repeater in entity invitation to send multiple emails if needed
    $('#entity-creation-invite-form').repeater({
        isFirstItemUndeletable: true
    });

    // Smooth scroll public homepage
    $('.public-header__menu-list .menu-list__item a').on('click', function(e) {
        e.preventDefault();
        var el = $(this).data('anchor');
        if (el != "" && $(el).length > 0) {
            var speed = 750;
            $('html, body').animate( { scrollTop: $(el).offset().top - 170 }, speed ); // Go
        }
        else {
            window.location.href = $(this).attr('href');
        }
    });

    $('.public-footer__links-list a').on('click', function(e) {
        e.preventDefault();
        var el = $(this).data('anchor');
        if (el != "" && $(el).length > 0) {
            var speed = 750;
            $('html, body').animate( { scrollTop: $(el).offset().top - 170 }, speed ); // Go
        }
        else {
            window.location.href = $(this).attr('href');
        }
    });

    $('.btn-moveup').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate( { scrollTop: 0 }, 750 ); // Go
    });


    /* PORTFOLIO PROJECT FORM
    ___________________________________________________________*/

    $(document).on('click touch', "#portfolio-invite-btn", function() {
        var data = $(this).parents('form').serialize();
        $('body').addClass('is-loading');

        $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'data': data + '&action=portfolio_invite_action',
            success: function (response) {
                var res = JSON.parse(response);
                // Display message
                swal({
                    title: res.message.title,
                    html: res.message.message,
                    type: res.message.type
                });
            }
        }).always(function () {
            $('body').removeClass('is-loading');
        });

    });

    $(document).on("submit",'#loadfromajax_portfolio_entity', function (e) {
        e.preventDefault();

        var data = new FormData(this);
        var page_url = $(this).attr('data-url');
        //console.log(page_url);
        $('body').addClass('is-loading');

        $.ajax({
            'url': ajaxurl,
            'type': 'POST',
            'processData': false,
            'contentType': false,
            'data': data,
            success: function (response) {
                var res = JSON.parse(response);
                // Display message
                swal({
                    title: res.message.title,
                    html: res.message.message,
                    type: res.message.type
                }).then((result) => {
                    window.location.href = page_url;
                });

                // Load new resource
                /*   var url = $('#dashboard-p-project-list-container').attr("data-url");
                   var ent_id = $('#dashboard-p-project-list-container').attr("data-ent-id");
                   $('#dashboard-p-project-list-container').load(url + "?ent_id=" + ent_id + " #dashboard-p-project-list-container>*");*/
            }
        }).always(function () {
            $('body').removeClass('is-loading');
        });


    });

    $(document).on('click touch','#portfolio-entity-modify-btn', function (e) {
        var pro_id = $(this).attr("data-portfolio-entity");
        $('body').addClass('is-loading');

        $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'data': '&project_id=' + pro_id + '&action=get_portfolio_entity_form_action',
            success: function (response) {
                var res = JSON.parse(response);
                $('#modify-portfolio-entity-container').empty().append(res).ready(function() {
                    $(".select_portfolio_entity_entity").each(function(){
                        $(this).select2({
                                ajax: {
                                    url: ajaxurl,
                                    dataType: 'json',
                                    type: 'GET',
                                    data: function(term) {
                                        return {
                                            term : term,
                                            action : 'get_entities_list_action'
                                        }
                                    },
                                    processResults: function (data) {
                                        return {
                                            results : data,
                                        }
                                    }
                                }
                            }
                        );
                    })
                });

            }
        }).always(function () {
            $('body').removeClass('is-loading');
        });
        e.preventDefault();
    });

    /* Swal message translations */


    $(document).on('click touch','#portfolio-entity-delete-btn', function (e) {
        swal({
            title: ilioSwal.swalDeleteTitle,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#f9b616',
            cancelButtonColor: '#ff6c7d',
            confirmButtonText: ilioSwal.swalDeleteConfirm,
            cancelButtonText: ilioSwal.swalDeleteCancel
        }).then((result) => {
            if (result.value) {

                var pro_id = $(this).attr("data-portfolio-entity");
                var ent_id = $(this).attr("data-entity");
                $.ajax({
                    'url': ajaxurl,
                    'type': 'GET',
                    'data': '&project_id=' + pro_id + '&ent_id=' + ent_id + '&action=delete_portfolio_entity_action',
                    success: function (response) {
                        var res = JSON.parse(response);
                        var url = $('#dashboard-p-project-list-container').attr("data-url");
                        var ent_id = $('#dashboard-p-project-list-container').attr("data-ent-id");
                        $('#dashboard-p-project-list-container').load(url + "?ent_id=" + ent_id + " #dashboard-p-project-list-container>*")

                    }
                });
            }
        });

        e.preventDefault();
    });

    /* PROJECT FORM
    ___________________________________________________________*/

    $(document).on("submit",'.loadfromajax_project', function (e) {
        var pageLink = $(this).attr("data-page-link");
        var parentContainerId = $(this).attr("data-parent-id");

        var thisForm = $(this);

        var data = new FormData(this);
        $('body').addClass('is-loading');

        $.ajax({
            'url': ajaxurl,
            'type': 'POST',
            'async': false,
            'processData': false,
            'contentType': false,
            'data': data,
            success: function () {
                $("#select_project_members").select2("destroy");
                //console.log(pageLink + ' #' + parentContainerId);

                $("#"+parentContainerId).load(pageLink + ' #' + parentContainerId + ">*", function() {
                    $("#select_project_members").select2({
                            ajax: {
                                url: ajaxurl,
                                dataType: 'json',
                                type: 'GET',
                                data: function(term) {
                                    return {
                                        term : term,
                                        action : 'get_members_list_action'
                                    }
                                },
                                processResults: function (data) {
                                    return {
                                        results : data,
                                    }
                                }
                            }
                        }
                    );

                    tinymce.execCommand( 'mceRemoveEditor', false, "project_short_description" );
                    tinymce.execCommand( 'mceAddEditor', false, "project_short_description" );
                });
            }
        }).always(function () {
            $('body').removeClass('is-loading');
        });

        e.preventDefault();
    });

    // Select of members

    $("#select_project_members").select2({
            ajax: {
                url: ajaxurl,
                dataType: 'json',
                type: 'GET',
                data: function(term) {
                    return {
                        term : term,
                        action : 'get_members_list_action'
                    }
                },
                processResults: function (data) {
                    return {
                        results : data,
                    }
                }
            }
        }
    );



    // Register form - company
    $('#project-status').on('change', function(e) {
        if ($(this).val() == 'ideation') {
            $('.register-block-entity').hide().find('input, textarea, button, select').attr('disabled', true);
            $('.register-block-project').show().find('input, textarea, button, select').attr('disabled', false);
        }
        else {
            $('.register-block-project').hide().find('input, textarea, button, select').attr('disabled', true);
            $('.register-block-entity').show().find('input, textarea, button, select').attr('disabled', false);
        }
    });

    $('input[name=entity_exists]').on('change', function() {
        if (this.value == 1) {
            $('.block-entity-not-exists').hide().find('input, textarea, button, select').attr('disabled', true);
            $('.block-entity-exists').show().find('input, textarea, button, select').attr('disabled', false);
        }
        else {
            $('.block-entity-exists').hide().find('input, textarea, button, select').attr('disabled', true);
            $('.block-entity-not-exists').show().find('input, textarea, button, select').attr('disabled', false);
        }
    });

    $('input[name=entity_permission]').on('change', function() {
        if (this.value == 1) {
            $('.block-entity-not-permission').hide().find('input, textarea, button, select').attr('disabled', true);
            $('.block-entity-permission').show().find('input, textarea, button, select').attr('disabled', false);
        }
        else {
            $('.block-entity-permission').hide().find('input, textarea, button, select').attr('disabled', true);
            $('.block-entity-not-permission').show().find('input, textarea, button, select').attr('disabled', false);
        }
    });

    $('#button-show-entity-form').on('click', function(e) {
        e.preventDefault();
        $('.block-entity-exists').hide().find('input, textarea, button, select').attr('disabled', true);
        $('.block-entity-not-exists').show().find('input, textarea, button, select').attr('disabled', false);
    });

    // Register form - submission
    $('#register-form').on('submit', function(e) {
        e.preventDefault();
        var formData = new FormData(this);
        //formData.set('g-recaptcha-response', grecaptcha.getResponse());
        formData.append('g-recaptcha-response', grecaptcha.getResponse());
        $('body').addClass('is-loading');

        $.ajax({
            type: 'post',
            url: ajaxurl,
            data: formData,
            processData: false,
            contentType: false,
            success: function (data) {
                var res = JSON.parse(data);
                if (res.success == true) {
                    // Redirect to next step
                    window.location.href = res.redirect_url;
                }
                else {
                    // Display error message
                    swal({
                        title: res.message.title,
                        html: res.message.message,
                        type: res.message.type
                    });
                }
            },
            error: function (data) {
                //console.log(data);
            }
        }).always(function () {
            $('body').removeClass('is-loading');
        })
    });

    var ajaxInProgress = false;

    // Register final form - submission
    $('#register-final-form').on('submit', function(e) {
        e.preventDefault();

        if(ajaxInProgress) {return;}

        ajaxInProgress = true;

        $("#final-form-submit").prop('disabled', true);

        $('body').addClass('is-loading');

        $.ajax({
            type: 'post',
            url: ajaxurl,
            async: false,
            data: new FormData(this),
            processData: false,
            contentType: false,
            success: function (data) {
                var res = JSON.parse(data);
                if (res.success == true) {
                    // Redirect to next step
                    window.location.href = res.redirect_url;
                }
                else {
                    // Display error message
                    swal({
                        title: res.message.title,
                        html: res.message.message,
                        type: res.message.type
                    });
                    $("#final-form-submit").prop('disabled', false);
                    ajaxInProgress = false;
                }
            },
            error: function (data) {
                //console.log(data);
            }
        }).always(function () {
            $('body').removeClass('is-loading');
        })
    });

    $('#send-activation-link').on('click', function(e) {
        e.preventDefault();

        $.post($(this).attr('href'), function (data) {
            var res = JSON.parse(data);

            swal({
                title: res.message.title,
                html: res.message.message,
                type: res.message.type
            });
        })
    });

    $('#entity-create-form').on('submit', function(e) {
        e.preventDefault();

        $('body').addClass('is-loading');

        $.ajax({
            type: 'post',
            url: ajaxurl,
            async: false,
            data: new FormData(this),
            processData: false,
            contentType: false,
            success: function (data) {
                var res = JSON.parse(data);

                if (res.success == true) {
                    if (res.type == 'create') {
                        window.location.href = res.redirect_url;
                    }
                    else {
                        swal({
                            title: res.message.title,
                            text: res.message.message,
                            type: 'success'
                        }).then((result) => {
                            window.location.href = res.redirect_url;
                        })
                    }
                }
                else if (res.success == 'continue') {
                    $('input[name="valid_entity"]').val(1);
                }
                else {
                    if (res.type == 'join') {
                        swal({
                            title: res.message.title,
                            text: res.message.message,
                            type: 'info'
                        }).then((result) => {
                            window.location.href = res.redirect_url;
                        })
                    }
                    else {
                        if (res.message.type == 'warning') {
                            swal({
                                title: res.message.title,
                                text: res.message.message,
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#f9b616',
                                cancelButtonColor: '#e9ecf0',
                                confirmButtonText: res.confirm_text,
                                cancelButtonText: res.cancel_text
                            }).then((result) => {
                                if (result.value) {
                                    // Allow user to create an entity with same name as existing
                                    $('input[name="allow_duplicate"]').val(1);
                                    $('#entity-create-form').submit();
                                }
                            })
                        }
                        else {
                            // Display error message
                            swal({
                                title: res.message.title,
                                html: res.message.message,
                                type: res.message.type
                            });
                        }
                    }
                }
            },
            error: function (data) {
                //console.log(data);
            }
        }).always(function () {
            $('body').removeClass('is-loading');
        })
    });

    $('.entity-add-member-form').on('submit', function(e) {
        e.preventDefault();
        $('body').addClass('is-loading');

        $.ajax({
            type: 'post',
            url: ajaxurl,
            data: $(this).serialize(),
            success: function (data) {
                var res = JSON.parse(data);
                swal({
                    title: res.message.title,
                    html: res.message.message,
                    type: res.message.type
                });

                if (res.success == true) {
                    if ($('.pending-user-content').hasClass('d-none')) {
                        $('.pending-user-content').removeClass('d-none');
                    }
                    $('#pending-entity-user').append(res.content);
                }
            },
            error: function (data) {
                //console.log(data);
            }
        }).always(function () {
            $('body').removeClass('is-loading');
        })
    });

    $('.entity-delete-member-form').on('submit', function(e) {
        e.preventDefault();

        swal({
            title: ilioSwal.swalWarningText,
            html: ilioSwal.swalDeleteUser,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#f9b616',
            cancelButtonColor: '#ff6c7d',
            confirmButtonText: ilioSwal.swalDeleteConfirm,
            cancelButtonText: ilioSwal.swalDeleteCancel
        }).then((result) => {
            if (result.value) {

                $('body').addClass('is-loading');

                $.ajax({
                    type: 'post',
                    url: ajaxurl,
                    data: $(this).serialize(),
                    success: function (data) {
                        var res = JSON.parse(data);
                        swal({
                            title: res.message.title,
                            html: res.message.message,
                            type: res.message.type
                        });

                        if (res.success == true) {
                            // add new option in select2
                            var newOption = new Option(res.name, res.id, false, false);
                            $('#search-member').append(newOption).trigger('change');
                            $('#member-' + res.id).hide();
                            $('#member-user-' + res.id).hide();
                            $('#member-entity-' + res.id).hide();
                        }
                    },
                    error: function (data) {
                        //console.log(data);
                    }
                }).always(function () {
                    $('body').removeClass('is-loading');
                })
            }
        });
    });

    $('body').on('submit', '.send-friend-invitation', function(e) {
        e.preventDefault();
        var form = $(this);

        if (form.find('.friend-form-follow-action').val() == 'delete') {
            swal({
                title: ilioSwal.swalWarningText,
                html: ilioSwal.swalDeleteUserFromList,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#f9b616',
                cancelButtonColor: '#ff6c7d',
                confirmButtonText:  ilioSwal.swalDeleteConfirm,
                cancelButtonText: ilioSwal.swalDeleteCancel
            }).then((result) => {
                if (result.value) {

                    $('body').addClass('is-loading');

                    $.ajax({
                        type: 'post',
                        url: ajaxurl,
                        data: form.serialize(),
                        success: function (data) {
                            var res = JSON.parse(data);
                            swal({
                                title: res.message.title,
                                html: res.message.message,
                                type: res.message.type
                            });

                            if (res.success == true) {
                                // Check if the action was create an invitation or delete from friend list
                                if (res.follow_action == 'create') {
                                    if (res.id !== false) {
                                        $('#member-user-' + res.id).hide();
                                    }
                                    else {
                                        // Change the form from "remove friend" to "add as friend"
                                        form.find('.friend-form-follow-action').val(res.follow_action);
                                        form.find('.friend-form-action').val(res.action);
                                        form.find('.friend-form-button').html(res.button_label);
                                    }
                                }
                                if (res.follow_action == 'pending') {
                                    // Change the form from "add as friend" to "pending request"
                                    form.find('.friend-form-follow-action').hide();
                                    form.find('.friend-form-action').hide();
                                    form.find('.friend-form-button').html(res.button_label).prop('disabled', true);
                                }
                            }
                        },
                        error: function (data) {
                            //console.log(data);
                        }
                    }).always(function () {
                        $('body').removeClass('is-loading');
                    })
                }
            });
        }
        else {
            $('body').addClass('is-loading');

            $.ajax({
                type: 'post',
                url: ajaxurl,
                data: form.serialize(),
                success: function (data) {
                    var res = JSON.parse(data);
                    swal({
                        title: res.message.title,
                        html: res.message.message,
                        type: res.message.type
                    });

                    if (res.success == true) {
                        // Check if the action was create an invitation or delete from friend list
                        if (res.follow_action == 'create') {
                            if (res.id !== false) {
                                $('#member-user-' + res.id).hide();
                            }
                            else {
                                // Change the form from "remove friend" to "add as friend"
                                form.find('.friend-form-follow-action').val(res.follow_action);
                                form.find('.friend-form-action').val(res.action);
                                form.find('.friend-form-button').html(res.button_label);
                            }
                        }
                        if (res.follow_action == 'pending') {
                            // Change the form from "add as friend" to "pending request"
                            form.find('.friend-form-follow-action').hide();
                            form.find('.friend-form-action').hide();
                            form.find('.friend-form-button').html(res.button_label).prop('disabled', true);
                        }
                    }
                },
                error: function (data) {
                    //console.log(data);
                }
            }).always(function () {
                $('body').removeClass('is-loading');
            })
        }

    });

    $('#carto-load-more').on('click', function(e) {
        e.preventDefault();
        $('body').addClass('is-loading');

        $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'async': true,
            'data': $('#carto-form').serialize(),
            success: function(response) {
                var res = JSON.parse(response);
                $('#carto-search-results').append(res['posts']);
                $('#carto-paged').attr('value', res['paged']);

                if (res['max'] === true) {
                    $('#carto-load-more').addClass('d-none');
                }
            },
        }).always(function () {
            $('body').removeClass('is-loading');
        });
    });

    $('#carto-form').on('submit', function(e) {
        e.preventDefault();

        $('#carto-paged').attr('value', 1);
        $('body').addClass('is-loading');

        $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'async': true,
            'data': $('#carto-form').serialize(),
            success: function(response) {
                var res = JSON.parse(response);
                $('#carto-search-results').html(res['posts']).show();
                $('#carto-paged').attr('value', res['paged']);

                if (res['max'] === true) {
                    $('#carto-load-more').addClass('d-none');
                }
                else {
                    if ($('#carto-load-more').hasClass('d-none')) {
                        $('#carto-load-more').removeClass('d-none');
                    }
                }

                $('html, body').animate({
                    scrollTop: $('#carto-search-results').offset().top - 200
                }, 650);
            },
        }).always(function () {
            $('body').removeClass('is-loading');
        });
    });

    $('.toggle-menu-static, .public-header__close, .menu-list__item a').on('click', function(e) {
        e.preventDefault();

        $('.menu-burger').toggleClass('is-active');
        $('.public-header__menu').toggleClass('public-header__menu--active');
    });

    $('.toggle-menu-dashboard, .public-header__close').on('click', function(e) {
        e.preventDefault();

        $('.menu-burger').toggleClass('is-active');
        $('.header-navbar').toggleClass('header-navbar--active');
        $('.header-navigation').toggleClass('header-navigation--active');
    });
});

// WINDOW LOAD
$(window).on('load', function() {

    $.fn.createlogo();

    // Activate Animation On Scroll
    AOS.init();

    equalizeBlocks();
    squareBlocks();

    // Fade in slider on page load
    $('.pp-slider').on('init', function(event, slick) {
        $(this).css({
            'opacity': 1,
            'visibility': 'visible'
        });
    });

    // Home Slider
    $('.slider-home').slick({
        infinite: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1000,
    });

    $('.slider-ref').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 1000,
        dots: true,
        arrows: false,
    });

    $('.dashboard-suggestions-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

});

// WINDOW RESIZE
$(window).resize(function () {
    squareBlocks();
    equalizeBlocks();
});

(function ($) {
    var hash = window.location.hash;

    if (hash) {
        var target = hash.replace('#', '');
        if (target.indexOf("/") == -1) {
            // delete hash so the page won't scroll to it
            window.location.hash = "";

            $(window).on('load', function () {
                // Scroll to anchor on page init
                if (target) {
                    if ($(hash).length > 0) {
                        $('html, body').animate({
                            scrollTop: $(hash).offset().top - 170
                        }, 750);
                    }

                    return false;
                }
            });
        }
    }

    $(window).on('load', function() {
        var md = new MobileDetect(window.navigator.userAgent);
        if (md.mobile()) {
            $('[data-lity]').removeAttr('data-lity')
        }
    })
})(jQuery);

(function($) {
    $(window).scroll(function() {
        if (window.pageYOffset > 0) {
            $('.header-navbar').addClass('header-navbar--fixed');
        }
        else {
            $('.header-navbar').removeClass('header-navbar--fixed');

        }

        if (window.pageYOffset > 115) {
            $('.public-header').addClass('public-header--fixed');
            $('.btn-moveup').fadeIn();
        }
        else {
            $('.public-header').removeClass('public-header--fixed');
            $('.btn-moveup').hide();
        }
    })
})(jQuery);

(function($) {
    /**
     * Move the info form to next step according to selected options
     * @param currentStep
     */
    function formInfoNext(currentStep) {
        var nextStep = currentStep + 1;

        if (currentStep == 1) {
            var selected = $('input[name="info-form[profile_type][]"]:checked').length;

            // Check how many options were selected :
            // --> More 1 => go to step 2
            if (selected > 1) {
                nextStep = 2;
            }
            // --> Only 1 => check what option was selected :
            else {
                var selectedValue = $('input[name="info-form[profile_type][]"]:checked').val();

                // ----> Entrepreneur => go to step 4
                // ----> Investisseur => go to step 9
                // ----> Any other => go to step 13
                if (selectedValue == 'entrepreneur') {
                    nextStep = 4;
                }
                else if (selectedValue == 'investisseur') {
                    nextStep = 9;
                }
                else {
                    nextStep = 13;
                }
            }
        }
        else if (currentStep == 2) {
            // Check which option was selected

            // --> option 1 => check what option was selected in step 1 :
            if ($('input[name="info-form[choice_form]"]:checked').val() == 1) {
                var selectedFields = $('input[name="info-form[profile_type][]"]:checked');
                var selectedArray = [];

                for (var i = 0; i < selectedFields.length; i++) {
                    selectedArray.push($(selectedFields[i]).val());
                }

                // ----> Entrepreneur => go to step 4
                // ----> Investisseur => go to step 9
                // ----> Any other => go to step 13
                if (selectedArray.indexOf('entrepreneur') !== '-1') {
                    nextStep = 4;
                }
                else if (selectedArray.indexOf('investisseur') !== '-1') {
                    nextStep = 9;
                }
                else {
                    nextStep = 13;
                }
            }

            // --> option 2 => go to step 3
            else {
                nextStep = 3;
            }

        }
        else if (currentStep == 3) {
            // Check what option was selected :

            var stepThreeSelected = $('input[name="info-form[main_profile_type]"]:checked').val();
            // ----> Entrepreneur => go to step 4
            // ----> Investisseur => go to step 9
            // ----> Any other => go to step 13

            if (stepThreeSelected == 'entrepreneur') {
                nextStep = 4;
            }
            else if (stepThreeSelected == 'investisseur') {
                nextStep = 9;
            }
            else {
                nextStep = 13;
            }
        }
        else if (currentStep == 8) {
            // If only 1 option was selected in step 1 or 3 and was entrepreneur, end it here
            if ($('input[name="info-form[profile_type][]"]:checked').length == 1 ||
                $('input[name="info-form[main_profile_type]"]:checked').length == 1) {
                // Submit form
                submitInfoForm();
            }

            // If multiple options were selected in step 1, check the other choices :
            else {
                // If user chose option 1 in step 2, redirect to other forms
                // --> if investisseur is part of the array => go to step 9
                // --> else if any other was part of the array => go to step 13
                if ($('input[name="info-form[choice_form]"]:checked').val() == 1) {
                    var selectedFields = $('input[name="info-form[profile_type][]"]:checked');
                    var selectedArray = [];

                    for (var i = 0; i < selectedFields.length; i++) {
                        selectedArray.push($(selectedFields[i]).val());
                    }

                    // ----> Investisseur => go to step 9
                    // ----> Any other => go to step 13
                    if (selectedArray.indexOf('investisseur') != '-1') {
                        nextStep = 9;
                    }
                    else {
                        nextStep = 13;
                    }
                }
                // If user chose option 2 in step 2, submit the form
                else {
                    // Submit form
                    submitInfoForm();
                }
            }

        }
        else if (currentStep == 12) {
            // If only 1 option was selected in step 1 or 3 and was investisseur, end it here
            // If only 1 option was selected in step 1 or 3 and was entrepreneur, end it here
            if ($('input[name="info-form[profile_type][]"]:checked').length == 1 ||
                $('input[name="info-form[main_profile_type]"]:checked').length == 1) {
                // Submit form
                submitInfoForm();
            }

            // If multiple options were selected in step 1, check the other choices :
            else {
                // If multiple options were selected in step 1, check the other choices :
                // --> if any option other than entrepreneur and investisseur was part of the array => go to step 13
                // --> else, end it here
                if ($('input[name="info-form[choice_form]"]:checked').val() == 1) {
                    var selectedFields = $('input[name="info-form[profile_type][]"]:checked');
                    var selectedArray = [];

                    for (var i = 0; i < selectedFields.length; i++) {
                        if ($(selectedFields[i]).val() != 'entrepreneur' && $(selectedFields[i]).val() != 'investisseur') {
                            selectedArray.push($(selectedFields[i]).val());
                        }
                    }

                    // ----> Still another option => go to step 13 to pursue the general workflow
                    if (selectedArray.length > 0) {
                        nextStep = 13;
                    }
                    else {
                        // Submit form
                        submitInfoForm();
                    }
                }
                // If user chose option 2 in step 2, submit the form
                else {
                    // Submit form
                    submitInfoForm();
                }
            }


        }
        else if (currentStep == 14) {
            // Submit form
            submitInfoForm();
        }

        // mettre un data-step au bouton précédent avec la valeur de currentStep
        if (nextStep >= 1 && nextStep <= 14) {
            $('.info-form__step').hide();
            $('.info-form__step[data-step="' + nextStep + '"]').fadeIn()
        }
        else {
            // Submit form
            submitInfoForm();
        }
    }

    /**
     * Move to previous step
     * @param prevStep
     */
    function formInfoPrev(prevStep) {
        $('.info-form__step').hide();
        $('.info-form__step[data-step="' + prevStep + '"]').fadeIn()
    }

    /**
     * Submit the info form
     */
    function submitInfoForm() {
        console.log("test");
        $('body').addClass('is-loading');
        $('#profileInfoModal').modal('hide');
        $('#profileInfoModal').on('hidden.bs.modal', function (e) {
            $('body').addClass('is-loading');
            var data = $("#form-infos-modal").serialize();
            $.ajax({
                'url': ajaxurl,
                'type': 'POST',
                'async': false,
                'data': data + '&action=update_user_info_data_action',
                success: function (response) {
                    location.reload();
                }
            }).always(function () {
                $('body').removeClass('is-loading');
            });
        });
    }

    $('.infos-step-back').on('click', function(e) {
        e.preventDefault();

        // Get the previous step stored on previous button
        var prevStep = parseInt($('.info-form__step:visible .infos-step-back').data('prev-step'));

        formInfoPrev(prevStep);

    });

    $('#form-infos-modal').on('submit', function(e) {
        // Prevent the form from being submitted
        e.preventDefault();

        // Check the current step, compare with final step
        // Move forward to the corresponding step when submitting the form

        // Breakpoints are steps :
        // 1
        // 2 : visible if multiple options were selected in step 1
        // 3 : visible if option 1 was selected in step 2
        // 4-8 : visible only if ENTREPRENEUR was selected in step 1 OR if
        // 9-12 : visible only if INVESTISSEUR was selected in step 1
        // 13-14 : visible only if ENTREPRENEUR AND INVESTISSEUR were NOT selected in step 1

        // Get the current step
        var currentStep = $('.info-form__step:visible').data('step');

        // Go to the next step
        formInfoNext(currentStep);

        // Update the new step's previous button with the previous step (stored in the scope in currentStep var)
        $('.info-form__step:visible .infos-step-back').attr('data-prev-step', currentStep);


    })

    // Tu slide sur l'element qui
    $('input[type=radio]').on('click', function(){
        if ($(this).attr('class') === 'has-answer') {
            $(".different-choice").hide();
            var id = $(this).attr('id');
            var answerID = '#' + id + '_answer';
            $(answerID).show();
        }
    });

    $('.opened_block').on('click', function(){
        open_bloc()
    });


    $('.closing_block').on('click', function(){
        close_bloc()

    });

    if (localStorage.getItem("infoButton") === "close") {
        close_bloc()
    }

    if (localStorage.getItem("infoButton") === "open") {
        open_bloc();
    }

    function open_bloc() {
        $(".profil_button_info_close").hide();
        $(".profil_button_info_open").show();
        localStorage.setItem('infoButton', 'open');

    }

    function close_bloc() {
        $(".profil_button_info_open").hide();
        $(".profil_button_info_close").show();
        localStorage.setItem('infoButton', 'close');
    }

    // Post mentions with "@"

    // Find caret position in text area to upgrade left and right position of autocomplete 'ul'
    var caretTopPosition = 0;
    var caretLeftPosition = 0;

    document.querySelector('textarea').addEventListener('input', function () {
        var caret = getCaretCoordinates(this, this.selectionEnd);
        caretTopPosition = caret.top;
        caretLeftPosition = caret.left;


    });

    // initialize the mention plugin

    $.each( $('.post_content'), function(index, item) {
        $(item).mentionsInput({
            source: function( request, response ) {
                if (request.term.replace(/\s+/g, '').length > 2 ) {
                    $.ajax( {
                        url: ajaxurl,
                        dataType: "json",
                        data: {
                            action: "post_mentions_action",
                            term: request.term
                        },
                        success: response

                    } );
                }
            },
            showAtCaret: true,
            autocomplete: {
                open: function() {

                    $(".ui-autocomplete").css({left: caretLeftPosition + 5 + "px",
                        top: caretTopPosition + 15 + "px" });
                }
            }
        });
    });

    // initialize the mention plugin for comments

    $.each( $('.comment-form textarea'), function(index, item) {
        $(item).mentionsInput({
            source: function( request, response ) {
                if (request.term.replace(/\s+/g, '').length > 2 ) {
                    $.ajax( {
                        url: ajaxurl,
                        dataType: "json",
                        data: {
                            action: "post_mentions_action",
                            term: request.term
                        },
                        success: response

                    } );
                }
            },
            showAtCaret: true,
            autocomplete: {
                open: function() {

                    $(".ui-autocomplete").css({left: caretLeftPosition + 5 + "px",
                        top: caretTopPosition + 15 + "px" });
                }
            }
        });
    });

    $('body').on('change', '.support-block-radio input', function(e) {
        if (this.value == 1) {
            $('.support-block').show();
            $('.support-block :input').prop('disabled', false);

        }
        else {
            $('.support-block').hide();
            $('.support-block :input').prop('disabled', true);
        }
    })

    $('body').on('change', '.financement-block-radio input', function(e) {
        if (this.value == 1) {
            $('.financement-block').show();
            $('.financement-block :input').prop('disabled', false);
        }
        else {
            $('.financement-block').hide();
            $('.financement-block :input').prop('disabled', true);
        }
    });

    $(document).on("click", ".share-popin .share-popin__social", function() {
        $(this).parents(".modal").modal('hide');
    });

    $('body').on('change', '.input-choice-parent', function(e) {
        e.preventDefault();
        $('.' + $(this).data('target')).hide();
        $('.' + $(this).data('target') + '-' + this.value).show();
    })

    $(document).on('click', '.btn-hide-post', function(e) {
        e.preventDefault();

        var postItem = $(this).parents('.nf-item');
        var data = 'post_id=' + $(this).data('post') + '&type=' + $(this).data('type') + '&did=' + $(this).data('did');

        // Launch ajax request to hide the post
        $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'async': false,
            'data': data + '&action=dashboard_hide_post_action',
            success: function (response) {
                postItem.fadeOut();
            }
        });
    });

    $(function() {
        $('.comment-form textarea#comment').attr('placeholder', ilioPost.postCommentPlaceholder);
        $('.comment-form textarea#comment').focus(function() {
            $(this).addClass('field-focused');
            $(this).parents('.comment-form').find('.form-submit').show();
        })
    })

})(jQuery);

// ----------------------------------------- //
// DOM READY
$(document).ready(function ($) {

    /*
     * On comment form submit
     */
    $('.comment-form').submit(function (e) {
        e.preventDefault();

        // define some vars
        var thisForm = $(this);
        var commentlist = $(this).parent().siblings(".nf-comments-list");

        if ( !$(thisForm).find('#comment').hasClass( 'error' ) ) {

            // ajax request
            $.ajax({
                type: 'POST',
                url: ajaxurl, // admin-ajax.php URL
                data: $(this).serialize() + '&action=ajax_comments', // send form data + action parameter

                error: function (request, status, error) {
                    if (status == 500) {

                    } else if (status == 'timeout') {

                    } else {
                        // process WordPress errors

                    }
                },
                success: function (response) {
                    var res = JSON.parse(response);
                    commentlist.append(res);

                    // clear textarea field
                    $(thisForm).find('#comment').val('');
                    $(thisForm).find('.highlighter-content').html('');
                },
                complete: function () {
                    // what to do after a comment has been added

                }
            });
        }

    });
});
